import "./styles.css";

function TodosError() {
  return <p>Ocurred an error!</p>;
}

export { TodosError };
